import { OpenAPI } from '@organization/api/requests'
import { getConfigInterceptors } from '@shared/utils'
import $axios, { RawAxiosRequestHeaders } from 'axios'

OpenAPI.BASE = import.meta.env.VITE_APP_MAIN_API

const defaultHeaders: RawAxiosRequestHeaders = {
  'Content-Type': 'application/json'
}

export const mainAxios = $axios.create({
  baseURL: import.meta.env.VITE_APP_MAIN_API,
  headers: defaultHeaders
})

getConfigInterceptors(mainAxios)
